import React, { useEffect, useMemo, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { get } from 'lodash';
import { AutoNumeric } from '../../common/AutoNumeric/AutoNumeric';
import { FieldWithTooltip } from '../../common/FieldWithTooltip/FieldWithTooltip';
import { PoFormField, PoFormLabel } from '../../constants/constants';

export const LocalSourceTotalCost = ({
  productIndexes,
}: {
  readonly productIndexes: number[];
}) => {
  const allocations = useWatch({ name: 'allocations' }) as any[];
  const costPerItem = useWatch({ name: PoFormField.CostPerItem }) as string;
  const products = useWatch({ name: 'products' }) as any[];
  const { setValue } = useFormContext();

  const [totalCostValue, setTotalCostValue] = useState('');

  useEffect(() => {
    const totalCost = productIndexes.reduce((sum, productIndex) => {
      const quantity = get(allocations, `[${productIndex}].quantity`, '');
      const productCostPerItem =
        productIndex === 0
          ? costPerItem
          : get(products, `[${productIndex}].${PoFormField.CostPerItem}`, '');
      const parsedQuantity = Number(String(quantity).replace(/,/g, '')) || 0;
      const parsedCostPerItem =
        Number(String(productCostPerItem).replace(/,/g, '')) || 0;

      return sum + parsedQuantity * parsedCostPerItem;
    }, 0);
    const formattedTotalCost = totalCost ? totalCost.toFixed(2) : '';

    setTotalCostValue(formattedTotalCost);
    setValue(PoFormField.TotalCost, formattedTotalCost);
  }, [allocations, costPerItem, productIndexes, products, setValue]);

  return useMemo(
    () => (
      <div style={{ flex: 1 }}>
        <FieldWithTooltip
          id={PoFormLabel.TotalCost}
          title={PoFormLabel.TotalCost}
          required
          currency
        >
          <Controller
            as={AutoNumeric}
            name={PoFormField.TotalCost}
            defaultValue=""
            imperativeMode
            imperativeValue={totalCostValue}
            options={{
              decimalPlaces: 2,
            }}
            placeholder=""
            disabled
            rules={{ required: true }}
          />
        </FieldWithTooltip>
      </div>
    ),
    [totalCostValue]
  );
};
